export enum FEATURE_APP_ID {
  USERS_MFE = 'users-mfe',
  DASHBOARD_MFE = 'dashboard-mfe',
  HELP_MFE = 'help-mfe',
  PROD_CONFIG_MFE = 'prod-config-mfe',
  CLIENT_CONFIG_MFE = 'client-config-mfe',
  SETTINGS_MFE = 'settings-mfe',
}

export enum FEATURE_SERVICE_VERSION {
  ASYNC_SSR_MANAGER = '^1.0.0',
  SERIALIZED_STATE_MANAGER = '^1.0.0',
}

export enum FEATURE_SERVICE_ID {
  ASYNC_SSR_MANAGER = 's2:async-ssr-manager',
}
